import './StoriesPrize.css'
import storiesLogo from '../../../../assets/images/storiesLogo.svg'
interface StoriesPrizeProps {
  image: string
  topText: string
  bottomText: string
}

const StoriesPrize = ({ image, topText, bottomText }: StoriesPrizeProps) => {
  return (
    <div className="stories-prize">
      <div className="stories-prize__content">
        <div className="stories-prize__top-text">{topText}</div>

        <div className="stories-prize__image-container">
          <img
            src={image}
            alt="Prize"
            className="stories-prize__image"
            crossOrigin="anonymous"
          />
        </div>

        <div className="stories-prize__logo">
          <img
            src={storiesLogo}
            alt=""
            crossOrigin="anonymous"
          />
        </div>

        <div className="stories-prize__bottom-text">{bottomText}</div>
      </div>
    </div>
  )
}

export default StoriesPrize
